<template>
  <div class="row">
    <vue-captcha ref="captcha" :captcha.sync="generatedCode"> </vue-captcha>
    <my-button fa="refresh" label="" variant="header-toggle" classes="ml-2" @onClick="refresh"></my-button>

    <my-input
      id="captcha-code"
      name="captcha-code"
      mandatory="true"
      label=""
      :placeholder="$t(LangConstants.input_code_here)"
      inlinerows="false"
      inlinerowclasses="mb-0"
      classes="bg-gray"
      v-model="userCaptchaCode"
      @keyUp="verifyCode"
    ></my-input>
  </div>
</template>

<script>
import MyButton from "../atoms/Button.vue";
import MyInput from "../atoms/Input.vue";
import VueCaptcha from "vue-captcha-code";
import Constants from "../../constants/index";

export default {
  name: "captcha",

  data() {
    return {
      generatedCode: "",
      userCaptchaCode: "", // Bind this to the input field
    };
  },

  methods: {
    refresh() {
      this.$refs.captcha.refreshCaptcha();
      this.$emit("isValid", false);
      this.userCaptchaCode = ""; // Reset the input value
    },

    verifyCode() {
      console.log("Generated Code:", this.generatedCode);
      console.log("User Captcha Code:", this.userCaptchaCode);

      if (this.generatedCode === this.userCaptchaCode) {
        this.$emit("isValid", true);
      } else {
        this.$emit("isValid", false);
      }
    },
  },

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  components: {
    MyButton,
    MyInput,
    VueCaptcha,
  },
};
</script>